import { state } from "@/state";
import { Box, Button, Stack, StackProps, Text } from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";
import { useSnapshot } from "valtio";

type Variant = "default" | "white";

const whiteVariant = {
  borderColor: "brand.100",
  color: "brand.100",
  _active: {
    bg: "brand.100",
    color: "brand.1000",
  },
};

export const RoleToggler = ({
  hideLabel = false,
  variant = "default",
  roles = ["coach", "master_coach", "enterprise"],
  buttonsProps,
  clickCallback,
  ...props
}: StackProps & {
  hideLabel?: boolean;
  variant?: Variant;
  roles?: string[];
  clickCallback?: (role: string) => void;
  buttonsProps?: StackProps;
}) => {
  const { role } = useSnapshot(state);
  const [localRole, setLocalRole] = useState("coach");

  const t = useTranslations();

  const isRoleActive = (role: string) => localRole === role;

  useEffect(() => {
    setLocalRole(role);
  }, [role]);

  return (
    <Stack
      direction={["column", "row"]}
      w="full"
      py={{
        base: 8,
        md: 12,
      }}
      px={{
        base: 12,
        md: 20,
      }}
      rounded={{
        base: "2xl",
        md: "full",
      }}
      justifyContent={"space-between"}
      alignItems={"center"}
      bgColor={"brand.1000"}
      color="brand.900"
      gap={4}
      {...props}
    >
      <Text
        display={hideLabel ? "none" : "block"}
        fontSize={"19px"}
        textAlign={{
          base: "center",
          md: "left",
        }}
      >
        {t("roles.selectRole")}
      </Text>
      <Box p={1} {...buttonsProps}>
        <Stack
          direction={["column", "row"]}
          alignItems="center"
          zIndex={0}
          position="relative"
          gap={6}
        >
          {roles.map((role) => (
            <Button
              key={role}
              position="relative"
              zIndex={2}
              className="roleToggle"
              variant="roleToggle"
              textTransform="uppercase"
              isActive={isRoleActive(role)}
              onClick={() => {
                state.role = role;
                clickCallback?.(role);
              }}
              {...(variant === "white" ? whiteVariant : {})}
            >
              {t(`roles.${role}`)}
            </Button>
          ))}
        </Stack>
      </Box>
    </Stack>
  );
};
